var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M26 0a6 6 0 110 12H6A6 6 0 116 0h20zm0 1.333H6a4.667 4.667 0 000 9.334h20a4.667 4.667 0 000-9.334zM26 4a2 2 0 110 4H6a2 2 0 110-4h20z"}})}
var staticRenderFns = []

export { render, staticRenderFns }